import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "feature-toggle",
    { attrs: { toggle: _vm.enableLinePricingGroupImport } },
    [
      _c(
        VMenu,
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c(
                    "tooltip",
                    {
                      attrs: {
                        value: _vm.$t("actions.uploadLinePricing.main"),
                        position: "bottom",
                      },
                    },
                    [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            staticClass: "ml-2",
                            attrs: {
                              small: "",
                              color: "primary",
                              loading: _vm.busyImportingLinePricingGroups,
                              disabled: _vm.disabled,
                              depressed: "",
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, { attrs: { small: "", left: "" } }, [
                            _vm._v("$import"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("actions.upload")) +
                              "\n          "
                          ),
                          _c(VIcon, [_vm._v("mdi-chevron-down")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            VList,
            [
              _vm.isPricingManager || _vm.isPricingSpecialist
                ? _c(
                    VListItem,
                    {
                      on: {
                        click: function ($event) {
                          return _vm.importLinePricingHandler({
                            importAG: false,
                          })
                        },
                      },
                    },
                    [
                      _c(VListItemTitle, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("actions.uploadLinePricing.workpackage")
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                VListItem,
                {
                  on: {
                    click: function ($event) {
                      return _vm.importLinePricingHandler({ importAG: true })
                    },
                  },
                },
                [
                  _c(VListItemTitle, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("actions.uploadLinePricing.ag")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }